import { createFileRoute } from '@tanstack/react-router';
import { DashboardCatalogTab } from '../../../pages/dashboard/catalog/DashboardCatalogTab';

export const Route = createFileRoute('/dashboard/catalog/')({ component: DashboardCatalogTab });
